import SecondStep from './SecondStep.component';

export default SecondStep;
